<h4>Bar Chart Widget Editor</h4>


<mat-tab-group>
  <mat-tab label="Appearance">
    <div>
      <mat-form-field>
        <mat-label>Title Label</mat-label>
        <input matInput [(ngModel)]="widget.title" name="widget.title">
      </mat-form-field>
    </div>

    <widget-background-colour [widget]="widget"></widget-background-colour>

    <widget-graph-colour-presets [widget]="widget"></widget-graph-colour-presets>
  </mat-tab>

  <mat-tab label="Data">   

    <div>
      <mat-form-field>
        <mat-label>x-Axis Label</mat-label>
        <input matInput [(ngModel)]="widget.xAxisLabel" name="widget.xAxisLabel">
      </mat-form-field>
    </div>

    <div>
      <mat-form-field>
        <mat-label>y-Axis Label</mat-label>
        <input matInput [(ngModel)]="widget.yAxisLabel" name="widget.yAxisLabel">
      </mat-form-field>

      <widget-datasource [dataSource]="widget.dataSource"></widget-datasource>
    </div>

  </mat-tab>

  <mat-tab label="Interactivity"> Interactivity </mat-tab>

  <mat-tab label="Alerts"> Alerts </mat-tab>
</mat-tab-group>
